define('models/Role',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var Role = ObservableModel.extend({
        defaults: {
            id: 0,
            name: ''
        }
    }, function () {});

    return Role;
});

